import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CommonConstants, DSComponents, DesignSystemHelperService } from '@frontend/promo-utils';
import { DsCard } from '@frontend/ui/card';
import { DynamicHtmlDirective } from '@frontend/vanilla/core';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';

import { RewardContent } from '../models/reward-content';

@Component({
    selector: 'tp-rewards',
    templateUrl: './rewards.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetDirective, NgStyle, DynamicHtmlDirective, NgClass, DsCard],
})
export class PromoRewardsComponent {
    @Input() rewardContent$: Observable<RewardContent>;
    dsComponents: DSComponents;
    dsRewardPrize: DSComponents;

    constructor(private designSystemHelperService: DesignSystemHelperService) {
        this.dsComponents = this.designSystemHelperService.getDsComponentsList();
        this.dsRewardPrize = this.designSystemHelperService.getDsComponentsList(CommonConstants.RewardPrize);
    }

    rewardsToggle(id: string): void {
        const headerEl = document.getElementById(id + '__header');
        const tncClassList = headerEl?.classList;
        const bodyEl = document.getElementById(id + '__body');
        const tncDescription = bodyEl?.classList;
        tncClassList?.toggle('theme-down');
        tncClassList?.toggle('theme-up');
        tncDescription?.toggle('collapsible-visible');
    }
}
